module.exports = __webpack_public_path__ + "img/google-discovery-phone.3abb4521.png";